import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import ScienceIcon from '@mui/icons-material/Science';
import SyntheticTestsTab from './SyntheticTestsTab';
import HealthCheckTab from './HealthCheckTab';

const ServiceOperationsSyntheticTab = () => {
  const [inner, setInner] = useState(0);

  return (
    <Box>
      <Paper elevation={0} sx={{ mb: 2, border: '1px solid rgba(0,0,0,0.12)', borderRadius: 1 }}>
        <Tabs
          value={inner}
          onChange={(_, v) => setInner(v)}
          sx={{ px: 1 }}
        >
          <Tab
            icon={<ScienceIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            label="Synthetic Tests"
            sx={{ minHeight: 44, textTransform: 'none', fontWeight: inner === 0 ? 700 : 400 }}
          />
          <Tab
            icon={<MonitorHeartIcon sx={{ fontSize: 16 }} />}
            iconPosition="start"
            label="Health Check"
            sx={{ minHeight: 44, textTransform: 'none', fontWeight: inner === 1 ? 700 : 400 }}
          />
        </Tabs>
      </Paper>

      {inner === 0 && <SyntheticTestsTab />}
      {inner === 1 && <HealthCheckTab />}
    </Box>
  );
};

export default ServiceOperationsSyntheticTab;
